import React, { useCallback } from 'react';
import SessionSection from '../../SessionSection';
import LiveBroadcast from '../../LiveBroadcast';
import { getAccessToken } from '../../../../../AuthToken';
import useRefinerSurvey from 'client/scripts/utils/useRefinerSurvey';

export default ({
    siteConf,
    eventUrls,
    session,
    me,
    showEmailLogin,
    sessionViewType,
    event,
    setVirtualSessionDetails,
    currentVirtualSessionDetails,
    scrollToBroadcast,
    setScrollToSessionBroadcastAction,
    setRecordUrl,
    recordUrl,
    isWebLoginV2Used,
    ticketsSelectionData,
    isPreliminaryAccessEnabled,
    setLoginV2SpinnerOrigin,
    setLoginV2OffsetTop,
    loginV2LoadingState,
}) => {
    const { recordingSession = {} } = session || {};
    const { recordingIsReady = false } = recordingSession;

    const bizzaboToken = getAccessToken();
    const isAuthenticated = !!(me?.id || bizzaboToken);
    const userEmail = me?.primaryEmail ?? null;
    const { color1, isWidget } = siteConf;

    const { id, primaryEmail, firstName } = me;
    const surveyId = '7bc9e000-4b48-11eb-a466-ab3a0da60c9b';
    useRefinerSurvey({ id, email: primaryEmail, name: firstName, surveyId });

    const broadcastRef = useCallback(node => {
        if (node !== null) {
            scrollIntoBroadcastSection(node);
        }
    }, []);

    function scrollIntoBroadcastSection(node) {
        if (scrollToBroadcast && !isWidget) {
            node.scrollIntoView(true);
            setScrollToSessionBroadcastAction(false);
        }
    }

    return (
        <div ref={broadcastRef}>
            <SessionSection
                color={color1}
                className="session-broadcast-container"
                classChildren={'margin-none'}
                stickSectionsToLeft>
                <div className='live-broadcast-container'>
                    <LiveBroadcast
                        session={session}
                        sessionViewType={sessionViewType}
                        eventUrls={eventUrls}
                        isAuthenticated={isAuthenticated}
                        showEmailLogin={showEmailLogin}
                        event={event}
                        setVirtualSessionDetails={setVirtualSessionDetails}
                        currentVirtualSessionDetails={currentVirtualSessionDetails}
                        userEmail={userEmail}
                        recordingIsReady={recordingIsReady}
                        scrollIntoBroadcastSection={scrollIntoBroadcastSection}
                        setRecordUrl={setRecordUrl}
                        recordUrl={recordUrl}
                        customColor={color1}
                        isWebLoginV2Used={isWebLoginV2Used}
                        setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                        loginV2LoadingState={loginV2LoadingState}
                        siteConf={siteConf}
                        user={me}
                        ticketsSelectionData={ticketsSelectionData}
                        isPreliminaryAccessEnabled={isPreliminaryAccessEnabled}
                    />
                </div>
            </SessionSection>
        </div>
    );
};
